import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { customSessionClient } from "better-auth/client/plugins";
import type { auth } from "@/lib/auth"; // Import the auth instance as a type

// Create auth client with proper session handling
const authClient = createAuthClient({
  plugins: [adminClient(), customSessionClient<typeof auth>()],
});

export const { signIn, signOut, getSession, signUp, admin, useSession } =
  authClient;
